<template>
  <div>
    <slot name="panels" />
    <slot name="gallery" />
    <slot name="settings" />
    <slot name="add-btn" />
    <slot name="modals" />

    <fab-speed-dial
      position-type="fixed"
      icon-size="small"
      :position="position"
      :bg-color="bgColor"
      :actions="fabActions"
      @addNewPanel="handleAddPanel"
      @addOnAir="handleAddOnAir"
      @addActivityFeed="handleAddActivityFeed"
      @addTwitterTrends="handleAddTwitterTrends"
      @addInstantPoll="handleAddInstantPoll"
      @addChat="handleAddChat"
    />
  </div>
</template>

<script>
import FabSpeedDial from '@/components/common/FabSpeedDial';
import InstantPoll from '@/components/interaction/InstantPoll';

export default {
  name: 'Dashboard',

  components: {
    FabSpeedDial,
    InstantPoll,
  },

  data: () => ({
    bgColor: '#ee2465',
    position: 'bottom-right',
    fabActions: [
      {
        name: 'addActivityFeed',
        icon: 'fa fa-fw fa-rss',
        tooltip: 'Activity Feed',
      },
      {
        name: 'addOnAir',
        icon: 'fa fa-fw fa-microphone',
        tooltip: 'On Air',
      },
      {
        name: 'addInstantPoll',
        icon: 'fa fa-fw fa-bolt',
        tooltip: 'New Instant Poll',
      },
      // {
      //   name: 'addTwitterTrends',
      //   icon: 'fa fa-fw fa-twitter',
      //   tooltip: 'Twitter Trends',
      // },
      {
        name: 'addChat',
        icon: 'fa fa-fw fa-comments',
        tooltip: 'Chat',
      },
      {
        name: 'addNewPanel',
        icon: 'fa fa-fw fa-file-text-o',
        tooltip: 'New panel',
      },
    ],
  }),

  methods: {
    handleAddPanel() {
      this.$emit('onAddPanel');
    },
    handleAddOnAir() {
      this.$emit('onShowPanel', ['onair', false]);
    },
    handleAddActivityFeed() {
      this.$emit('onShowPanel', ['activity', false]);
    },
    handleAddTwitterTrends() {
      this.$emit('onShowPanel', ['twittertrends', false]);
    },
    handleAddChat() {
      this.$emit('onShowPanel', ['chat', false]);
    },
    handleAddInstantPoll() {
      this.$emit('onInstantPoll', ['instantpoll', false]);
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/style/_variables_live.scss';

.message-panels {
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
}

.message-panel-container {
  white-space: normal;
  display: inline-block;
  margin-right: 15px;
  vertical-align: top;
}

.dashboard-header {
  padding: 10px;
}
</style>

<style lang="scss" scoped>
.page-wrapper {
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// Dashboard.vue?797c7309